import "./document-to-pdf.css";
import "./markdown-to-pdf.css";
import { renderDocumentPreview } from "./document-preview.js";
import { parseMarkdownDocument } from "./markdown-document-parser.js";
import { initializeDocumentPdfTool } from "./document-to-pdf-ui.js";

initializeDocumentPdfTool({
  mode: "markdown",
  parseSource: parseMarkdownDocument,
  renderPreview: renderDocumentPreview
});
